var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.checkStatus?['os-icon','disable']:['os-icon']},[_c('div',{staticClass:"os-element"},[_c('span',{staticClass:"os-system"},[_vm._v(_vm._s(_vm._item.osName))]),_c('span',{staticClass:"os-version"},[_vm._v(" "+_vm._s(_vm._item.osVersion)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }